import React, { useEffect, useState } from "react";
import { Col, Row, Space, notification } from "antd";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { userActions } from "../../store/user";
import userSelectors from "../../store/user/selectors";
import UserHeader from "./UserHeader";
import { useSearchParams } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import "./style.css";

const VerifyEmail = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const email: string = searchParams.get("email") ?? "";
  const token: string = searchParams.get("session_token") ?? "";
  const message: string = useAppSelector(userSelectors.emailVerifyMessage);
  const [timer, settimer] = useState(10);
  useEffect(() => {
    dispatch(
      userActions.emailVerification({
        email: email,
        session_token: token,
      })
    );
  }, [dispatch, email, token]);
  useEffect(() => {
    if (timer > 0) {
      const id = setTimeout(() => settimer((prev) => prev - 1), 1000);
      return () => clearTimeout(id);
    } else {
      navigate("/");
    }
  }, [timer, navigate]);
  return (
    <>
      <UserHeader /> {/* Header for user verification */}
      <div className="verify-container">
        <Row
          justify="center"
          align="middle"
          gutter={[0, 24]}
          className="text-center"
        >
          <Col span={24}>
            <Space direction="vertical" className="verify-button-container">
              <span className="user-header-text">Email verification </span>
              <hr className="text-white-color" />
              <span className="link">
                {message ? message : "verifing your email, please wait..."}
              </span>
              <span className="link">
                <LoadingOutlined /> &nbsp;&nbsp;Redirecting to Dashboard {timer > 0 ? `in ${timer} second` : ``} .....
              </span>
            </Space>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default VerifyEmail;
